import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";
import { limitedWidth } from "../../usedInExerciseNumber/StyledComponents";

export const TextSpan = styled.span`
    font-size: inherit;
    overflow-wrap: break-word;
    word-break: break-word;

    &.checked {
        color: ${DesignConstants.COLORS.P6_ORANGE};
    }
`;

export const CardWrapper = styled.div`
    width: 100%;
    padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.L};
    border-bottom: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    background: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    &:hover {
        background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};

        ${TextSpan} {
            &.checked {
                color: ${DesignConstants.COLORS.P6_ORANGE_DARKER};
            }
        }
    }
`;

export const CheckboxWrapper = styled.div`
    margin: 0;
    width: ${DesignConstants.FONT_SIZES.XXL};
    display: flex;
    align-items: center;
    justify-content: space-around;

    &.half-opacity {
        opacity: ${DesignConstants.OPACITY.SIX};
    }
`;

export const QuestionAnswerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
        gap: ${DesignConstants.SPACES.XXS};
    }
`;

export const AnswerColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const QuestionWrapper = styled.div`
    flex: 1;
    padding: 0 ${DesignConstants.SPACES.XXS};
    font-size: ${DesignConstants.FONT_SIZES.M};
    display: flex;
    align-items: center;
    min-height: ${DesignConstants.SPACES.L};
    min-width: 0;
`;

export const AnswerWrapper = styled.div`
    padding: 0 ${DesignConstants.SPACES.XXS};
    font-size: ${DesignConstants.FONT_SIZES.M};
    display: flex;
    align-items: center;
    min-height: ${DesignConstants.SPACES.L};
`;

export const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
        align-items: start;
    }
`;

export const RowContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;

    &.half-opacity {
        opacity: ${DesignConstants.OPACITY.SIX};
    }
`;

export const GapSentenceWrapper = styled.div`
    padding: 0 ${DesignConstants.SPACES.XXS};
    font-size: ${DesignConstants.FONT_SIZES.S};
`;

export const UsedInExerciseNumberPlaceholder = styled.div`
    min-width: ${limitedWidth};
    max-width: ${limitedWidth};
`;
